import React from 'react';
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { isAuthenticated } from '../utils/PrivateRoute';
import { logoutSession } from '../utils/authToken';
import { withRouter } from 'react-router-dom'
import * as firebase from "firebase/app";
import "firebase/auth";

const HeaderContainer = styled.div`
padding: 15px;
border-bottom: 1px solid rgba(0,0,0,.07);
display: flex;
justify-content: space-between;
align-items: center;
background-color: #2b303b;
color: #FFF;
`;

const HeaderLinks = styled.div`
display: flex
`

const HeaderLink = styled(Link)`
padding: 0 10px
`

function Header(props) {
  const isAuth = isAuthenticated();
  const logout = () => {
    firebase.auth().signOut();
    logoutSession();
    props.history.go('/dashboard')
  };
  return (
    <HeaderContainer>
      <div>PortfolioX</div>
      <HeaderLinks
      >
        {!isAuth && 
          <>
            <HeaderLink to="/signup" >Sign Up</HeaderLink>
            <HeaderLink to="/login" >Login</HeaderLink>
          </>
        }
        {
          isAuth && <HeaderLink to="/login" onClick={logout}>Logout</HeaderLink>
        }
      </HeaderLinks>
    </HeaderContainer>
  )
}

export default withRouter(Header)
